import { ResponseOption, ResponseOptionValue } from '@bighealth/types/src';

export const getDateTimePickerValue = (
  optionsAnswer: ResponseOption[]
): ResponseOptionValue => {
  return optionsAnswer[0].value;
};
